import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app.material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FeatureViewRoutingModule } from "./feature-view-routing.module";
import { FeatureViewComponent } from "./feature-view.component";
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FeatureAccessRightsComponent } from '../dialogs/feature-access-rights/feature-access-rights.component';
import { FeatureBusinessRuleComponent } from '../dialogs/feature-business-rule/feature-business-rule.component';
import { AddProfileDialogComponent } from '../dialogs/add-profile-dialog/add-profile-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FeatureViewRoutingModule,
        AppMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [
        FeatureViewComponent,
        FeatureAccessRightsComponent,
        FeatureBusinessRuleComponent,
        AddProfileDialogComponent
    ],
})
export class FeatureViewModule { }
